const definitions = {
    allergy: {
        definition: 'An alphabetical list of every medication allergy documented for the patients and their symptoms.',
        example: 'Search for reactions to Rx or OTC  meds; food allergies; etc.',
    },
    chiefComplaint: {
        definition: 'The symptom or the main reason for the doctor visit as presented by patient.',
        example: 'Search by reason for the patient’s visit in their own words.',
    },
    diagnosisHistory: {
        definition: 'An alphabetical list of every disease documented for all the patients. Searches can be made by typing in the specific disease name or using ICD codes.',
        example: 'Search by diagnosed disease, condition, or ICD code documented for patients.',
    },
    ejectionFraction: {
        definition: 'The volumetric fraction of fluid ejected from a heart chamber with each contraction. It can be used to indicate the health of the heart. The different types of tests used to obtain it are described.',
        example: 'Search results for ejection fractions.'
    },
    familyHistory: {
        definition: 'A list of all reported diseases among the family members of the patients.',
        example: 'Search for family history of cancer, heart disease, etc.'
    },
    labResult: {
        definition: 'A list of all reported results of patients’ lab tests.',
        example: 'Search results from blood tests including metabolic and lipid panels, CBC, etc.'
    },
    medicalOrderHistory: {
        definition: 'A list of various tests and orders for the patients entered by their provider.',
        example: 'Search by various tests ordered by the provider.'
    },
    medicationHistory: {
        definition: 'An alphabetical list of all the medicines the patients have been prescribed. Additional filters are available to search for dose, formulation etc.',
        example: 'Search for prescribed medications, OTC meds, supplements, etc'
    },
    pastMedicalHistory: {
        definition: 'A list of the patients’ past illnesses, diseases, surgeries, etc. documented at the patients’ visits.',
        example: 'Search for all prior illnesses and/or	diseases documented for patients.'
    },
    patientDemographics: {
        definition: 'A list of patient-reported demographics including gender, birth year, marital status, zip code, race, insurance type, etc.',
        example: 'Search by patient gender, age, race, insurance type, etc.'
    },
    procedureHistory: {
        definition: 'A list of all patients’ surgeries/procedures searchable by dates, description or CPT code.',
        example: 'Search by procedure name or CPT code.'
    },
    reviewOfSystems: {
        definition: 'An inventory of current signs and/or symptoms which the patient may be experiencing in the different body systems.',
        example: 'Search by patient symptoms such as chest pain, difficulty breathing, or signs such as rashes, lesions, etc.'
    },
    socialHistory: {
        definition: 'Texts inserted by the providers describing a plethora of patients’ various social issues involving smoking, alcohol, drugs, home life, number of children, etc.',
        example: 'Search for patients’ use of tobacco, alcohol, drugs, etc.'
    },
    vitalSignHistory: {
        definition: 'Measurements for BMI, blood pressures, pain scale, oximetry, vision.',
        example: 'Search by BMI, blood pressure, pain scale, etc.'
    },
    historyOfPresentIllness: {
        definition: 'Summary of patient’s current symptoms, the duration and progression, and any factors that may have triggered or worsened them.',
        example: 'Search to better understand the context and timeline of the illness.'
    },
    physicalExam: {
        definition: `A systematic examination of the patient's overall health and detect any signs of illness or abnormalities.`,
        example: 'Search for physician’s observations from patient’s periodic physical exams.'
    },
    pregnancyComments: {
        definition: 'Specific aspects of the physical examination of a pregnant woman that pertain to her pregnancy.',
        example: 'Search physician comments on the health and well-being of both the mother and the developing baby.'
    },
    assessment: {
        definition: `A doctor's evaluation and interpretation of the gathered information to form a professional opinion about the patient's current condition and treatment plan.`,
        example: `Search by reason of identifying potential diagnoses, ruling out certain conditions, and considerations for the patient's symptoms.`
    },
    plan: {
        definition: `The physician’s proposed course of action for the patient's care based on the assessment of the patient's condition.`,
        example: `Search for further diagnostic tests, specialty referrals, medications to be prescribed, lifestyle modifications, and follow-up appointments. `
    }

}
export default definitions;
